export default __webpack_public_path__ + "static/media/SEO_SVG.2e304004.svg";